module.exports = __webpack_public_path__ + "static/img/24ok.cdbf5b4c.webp";